import { FaQuestionCircle } from "react-icons/fa";
import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  title: "FAQ",
  name: "faqList",
  type: "object",
  icon: FaQuestionCircle,
  fields: [
    {
      name: "sectionLayoutConfig",
      type: "sectionLayoutConfig",
      title: "Section Layout",
      options: {
        collapsed: true,
        collapsable: true
      }
    },
    {
      name: "heading",
      title: "Section Heading",
      type: "sectionTitle",
      options: {
        collapsable: true
      }
    },
    {
      name: "questions",
      title: "Questions",
      type: "array",
      of: [{ type: "faqQuestion" }]
    }
  ],
  preview: {
    select: {
      title: "heading.title"
    },
    prepare(selection) {
      const { title } = selection;
      return {
        title: multilingualStringPreview(title) || "(FAQ)"
      };
    }
  }
});
